// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cU3gj7xDoEQMuPUDNsuC .wcE_9QRgFDYIymD8Igh6{height:44px;margin-top:40px;font-size:14px;font-weight:500}.cU3gj7xDoEQMuPUDNsuC .QtaKvyIuENUUBiRYf0pQ{margin-bottom:24px}.cU3gj7xDoEQMuPUDNsuC .SDUOcCZBgBswXTA6mF4F{padding:12px;font-size:14px;font-weight:400;line-height:20px}.cU3gj7xDoEQMuPUDNsuC .SDUOcCZBgBswXTA6mF4F.QtaKvyIuENUUBiRYf0pQ{margin-bottom:4px}.cU3gj7xDoEQMuPUDNsuC .XkvZOMBLIQYkx5ZqJNTl{margin-top:20px;margin-bottom:4px}.cU3gj7xDoEQMuPUDNsuC .YbuzSMg2HRs7O4_soR4s{justify-content:center;align-items:center;margin-top:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `cU3gj7xDoEQMuPUDNsuC`,
	"button": `wcE_9QRgFDYIymD8Igh6`,
	"error": `QtaKvyIuENUUBiRYf0pQ`,
	"textField": `SDUOcCZBgBswXTA6mF4F`,
	"inputLabel": `XkvZOMBLIQYkx5ZqJNTl`,
	"bottom": `YbuzSMg2HRs7O4_soR4s`
};
export default ___CSS_LOADER_EXPORT___;
